export default __webpack_public_path__ + "static/media/logo04.6dc17626.svg";